<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_table_of_contents_1"><span>Like No One Is Watching</span></h1>
<p class="P_Normal__And__Left_Indent">By Jaime Samms</p>
<p class="P_Normal__And__Left_Indent"> </p>
<p class="P_Normal__And__Left_Indent">Dance, Love, Live: Book One</p>
<p class="P_Normal__And__Left_Indent"> </p>
<p class="P_Normal">Dusty has finally landed a job he thinks he’ll be able to keep long-term, even with his broken brain and bum knee. He didn’t anticipate that cleaning a dance studio would reawaken his yearning to dance—even though he is no longer capable—or that meeting the studio’s director would rouse his dormant libido. Or his sleeping heart. </p>
<p class="P_Normal">Conrad thinks his life is finally complete with his successful dance studio and a steady stream of students. When Dusty arrives, he rediscovers his thirst for a man who will let him hand over control and give him the undivided attention he’s never had. The trouble is, Dusty isn’t sure he’s worthy of the studio director’s submission.</p>
<p class="P_Normal">To make their relationship work, Dusty will have to trust his ability to dominate the powerful and beautiful dancer, and Conrad will have to stop talking long enough to hear Dusty’s promises.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?08f319d6